import Vue from 'vue'
import Component from 'vue-class-component'
import { Feature } from '@/types'

@Component
export default class FeatureSetMixin extends Vue {
  featureKey!: Feature

  get featureEnabled () {
    return this.featureKey && this.can(this.featureKey)
  }

  can (key: Feature) {
    return this.$typedStore.features.featureOn(key)
  }
}
